import React from "react";
import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import "./ButtonWithIcon.scss";

const ButtonWithIcon = ({
  icon,
  text,
  onClick = () => {},
  className = "",
  disabled = false,
  type = "button",
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`button-with-icon ${className}`}
      disabled={disabled}
      {...rest}
    >
      {icon && <Icon icon={icon} className="button-icon" />}
      <span className="button-text">{text}</span>
    </button>
  );
};

ButtonWithIcon.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default ButtonWithIcon;
